const MONTH_NAMES = ['Led','Úno','Bře','Dub','Kvě','Čvn','Čvc','Srp','Zář','Říj','Lis','Pro']
const MONTHS = Array.from({ length: 12 }, (_, i) => i + 1)
const DAYS   = Array.from({ length: 31 }, (_, i) => i + 1)

function daysInMonth(year, month) {
  return new Date(year, month, 0).getDate()
}

const cellBorder = 'border-b border-r border-gray-200 last:border-r-0'

// getCellStyle(value) → { bg, text } | null
// formatCell(value)   → string  (výchozí: toFixed(1))
// orientation: 'normal' (řádky = dny, sloupce = měsíce) | 'transposed' (řádky = měsíce, sloupce = dny)
export function YlyGrid({ year, dataMap, getCellStyle, formatCell, orientation = 'normal' }) {
  const fmt = formatCell ?? (v => v.toFixed(1))
  const transposed = orientation === 'transposed'

  return (
    <div className="h-full overflow-hidden border border-gray-200">
      <div className="h-full overflow-auto">
        <table className="border-separate border-spacing-0 border-l-2 border-l-gray-400 border-r-2 border-r-gray-400 border-b-2 border-b-gray-400 text-xs">
          <thead>
            <tr>
              <th className={`sticky left-0 top-0 z-30 bg-gray-50 border-t-2 border-t-gray-400 border-b border-b-gray-400 border-r border-r-gray-400 px-2 py-1 text-gray-500 font-normal text-center ${transposed ? 'min-w-[2.5rem]' : 'min-w-[2rem]'}`}>
                {transposed ? 'Měsíc' : 'Den'}
              </th>
              {transposed
                ? DAYS.map(d => (
                    <th key={d} className={`sticky top-0 z-20 bg-gray-50 border-t-2 border-t-gray-400 border-b border-b-gray-400 ${cellBorder} px-1 py-1 text-gray-500 font-normal text-center min-w-[2.2rem]`}>
                      {d}.
                    </th>
                  ))
                : MONTHS.map(m => (
                    <th key={m} className={`sticky top-0 z-20 bg-gray-50 border-t-2 border-t-gray-400 border-b border-b-gray-400 ${cellBorder} px-1 py-1 text-gray-500 font-normal text-center min-w-[3.2rem]`}>
                      {MONTH_NAMES[m - 1]}
                    </th>
                  ))}
            </tr>
          </thead>
          <tbody>
            {transposed
              ? MONTHS.map(month => {
                  const maxDay = daysInMonth(year, month)
                  return (
                    <tr key={month} className="group">
                      <td className="sticky left-0 z-10 bg-gray-50 border-b border-b-gray-200 border-r border-r-gray-400 group-last:border-b-0 px-2 py-0.5 text-gray-500 text-center whitespace-nowrap">
                        {MONTH_NAMES[month - 1]}
                      </td>
                      {DAYS.map(day => {
                        if (day > maxDay) {
                          return <td key={day} className={`${cellBorder} group-last:border-b-0 px-1 py-0.5 bg-gray-100`} />
                        }
                        const key   = `${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
                        const value = dataMap.get(key) ?? null
                        const style = getCellStyle ? getCellStyle(value) : null
                        return (
                          <td
                            key={day}
                            style={style ? { backgroundColor: style.bg, color: style.text } : undefined}
                            className={`${cellBorder} group-last:border-b-0 px-1 py-0.5 text-right tabular-nums whitespace-nowrap ${!style ? 'text-gray-300' : ''}`}
                          >
                            {value != null ? fmt(value) : '—'}
                          </td>
                        )
                      })}
                    </tr>
                  )
                })
              : DAYS.map(day => (
                  <tr key={day} className="group">
                    <td className="sticky left-0 z-10 bg-gray-50 border-b border-b-gray-200 border-r border-r-gray-400 group-last:border-b-0 px-2 py-0.5 text-gray-500 text-center whitespace-nowrap">
                      {day}.
                    </td>
                    {MONTHS.map(month => {
                      const maxDay = daysInMonth(year, month)
                      if (day > maxDay) {
                        return (
                          <td
                            key={month}
                            className={`${cellBorder} group-last:border-b-0 px-1 py-0.5 bg-gray-100`}
                          />
                        )
                      }
                      const key   = `${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
                      const value = dataMap.get(key) ?? null
                      const style = getCellStyle ? getCellStyle(value) : null
                      return (
                        <td
                          key={month}
                          style={style ? { backgroundColor: style.bg, color: style.text } : undefined}
                          className={`${cellBorder} group-last:border-b-0 px-1 py-0.5 text-right tabular-nums whitespace-nowrap ${!style ? 'text-gray-300' : ''}`}
                        >
                          {value != null ? fmt(value) : '—'}
                        </td>
                      )
                    })}
                  </tr>
                ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
